module.exports = __webpack_public_path__ + "img/il.39dc4983.svg";